export default __webpack_public_path__ + "static/blob1-6299a95e1cbde2e76e8e95e59c1f3c4b.svg";